import { render } from "./Features4.vue?vue&type=template&id=6339b34c"
import script from "./Features4.vue?vue&type=script&lang=js"
export * from "./Features4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__